import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/views/physicalLabs/index.tsx");
